import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class TagClient {
    private readonly _http = inject(HttpClient);

    attachToTreatment(tagDisplayId: string, treatmentId: string) {
        return this._http.post(`/api/tags/${tagDisplayId}/treatments/${treatmentId}`, {});
    }

    removeFromTreatment(tagDisplayId: string, treatmentId: string) {
        return this._http.delete(`/api/tags/${tagDisplayId}/treatments/${treatmentId}`, {});
    }

    attachToOffice(tagDisplayId: string, officeId: string) {
        return this._http.post(`/api/tags/${tagDisplayId}/offices/${officeId}`, {});
    }

    removeFromOffice(tagDisplayId: string, officeId: string) {
        return this._http.delete(`/api/tags/${tagDisplayId}/offices/${officeId}`, {});
    }
}
